import * as React from "react";
import { GetFullBillingDetails_organization } from "../BillingDetails/__generated__/GetFullBillingDetails";
import DialogHESP from "../DialogHESP/DialogHESP";
import CreateCommitmentContract from "./CreateCommitmentContract";
import moment from "moment";

interface Props {
    open: boolean;
    onClose: () => void;
    organization: GetFullBillingDetails_organization;
}

export default function EditContractDialog({ open, onClose, organization }: Props) {
    const { billInGb, end, gbUsedPerMinute, hasAccessToSD, id, overageType, start } = organization.currentContract!;

    return (
        <DialogHESP
            title={"Create new contract period"}
            open={open}
            onClose={onClose}
            content={
                <CreateCommitmentContract
                    id={id}
                    organization={organization}
                    onClose={onClose}
                    defaultValues={{
                        billInGb,
                        endDate: moment(end),
                        gbUsedPerMinute,
                        hasAccessToSD,
                        overageType,
                        startDate: moment(start),
                    }}
                />
            }
        />
    );
}
